<template>
	<view>
		<view v-if="loading" class="lf_loading_box">
			<view class="lf_w32h32">
				<view class="lf_w32h32_0"></view>
				<view class="lf_w32h32_1 lf_animate-spin">
					<view class="lf_rounded-full"></view>
				</view>
				<view class="lf_w32h32_2 lf_animate-spin-reverse">
					<view class="lf_rounded-full"></view>
				</view>
				<view class="lf_w32h32_3 lf_animate-spin" style="animation-duration: 1.5s;">
					<view class="lf_rounded-full"></view>
				</view>
			</view>
		</view>
		<view class="lf_animation_" v-else>
			<navs v-if="backshow"></navs>
			<share></share>

			<Btn :match="match" :listmode="listmode" :match_set="match_set" :modellist="modellist" :modal="modal"
				:playoff="playoff" :matchhole="matchhole" :rd_id="rd_id"></Btn>
			<TDBG18 v-if="modal!='NetScore'&&matchmode=='TDBG18'" :matchmode="matchmode" :modal="modal"
				:matchhole="matchhole" :match="match" :match_set="match_set" :list="list" :teams="teams"
				:playoff="playoff" :rd_id="rd_id"></TDBG18>

			<TDBGSRLQ v-else-if="modal!='NetScore'&&matchmode=='TDBGSRLQ'" :matchmode="matchmode" :modal="modal"
				:matchhole="matchhole" :match="match" :match_set="match_set" :list="list" :teams="teams"
				:playoff="playoff" :rd_id="rd_id"></TDBGSRLQ>
			<TDBGSRSQ v-else-if="modal!='NetScore'&&matchmode=='TDBGSRSQ'" :matchmode="matchmode" :modal="modal"
				:matchhole="matchhole" :match="match" :match_set="match_set" :list="list" :teams="teams"
				:playoff="playoff" :rd_id="rd_id"></TDBGSRSQ>
			<TMDF42 v-else-if="modal!='NetScore'&&matchmode=='TDDF'" :matchmode="matchmode" :modal="modal"
				:matchhole="matchhole" :match="match" :match_set="match_set" :list="list" :teams="teams"
				:playoff="playoff" :rd_id="rd_id"></TMDF42>
			<Grbg v-else-if="modal!='NetScore'" :matchmode="matchmode" :modal="modal" :matchhole="matchhole"
				:match="match" :match_set="match_set" :list="list" :playoff="playoff" :rd_id="rd_id"></Grbg>
			<Grbg_net v-else-if="modal=='NetScore'&&(matchmode=='NNP_ZBCD'||matchmode=='ZBCD')" :matchmode="matchmode"
				:modal="modal" :matchhole="matchhole" :match="match" :match_set="match_set" :list="list"
				:playoff="playoff" :rd_id="rd_id"></Grbg_net>
			<Grbg_nnp v-else-if="modal=='NetScore'&&matchmode=='NNP'" :matchmode="matchmode" :modal="modal"
				:matchhole="matchhole" :match="match" :match_set="match_set" :list="list" :playoff="playoff"
				:rd_id="rd_id"></Grbg_nnp>
			<Ad></Ad>
		</view>
	</view>
</template>

<script>
	// @ is an alias to /src
	import navs from "../components/nav.vue";
	import Btn from "../components/Btn.vue";
	import Ad from "../components/Ad.vue";
	import Grbg from "../components/Match/GRBG.vue";
	import TMDF42 from "../components/Match/TMDF42.vue";
	import Grbg_net from "../components/Match/GRBG_net.vue";
	import Grbg_nnp from "../components/Match/GRBG_nnp.vue";
	import TDBG18 from "../components/Match/TEAM/TDBG18.vue";
	import TDBGSRSQ from "../components/Match/TEAM/TDBG_SRSQ.vue";
	import TDBGSRLQ from "../components/Match/TEAM/TDBG_SRLQ.vue";
	import share from "../components/share.vue";
	import axios from '../axios/request';
	import {
		getSystemLang,
		getLangAll
	} from "../lang";
	//这里就是更新后的路径，以前是import { Swiper, SwiperSlide } from 'swiper/vue'
	import {
		Swiper,
		SwiperSlide
	} from 'swiper/vue';

	import {
		Autoplay,
		Pagination
	} from 'swiper';
	import 'swiper/swiper-bundle.css';
	import 'swiper/swiper.min.css';
	//这里就是更新后的路径，以前是import 'swiper/css'

	//自动轮播的配置
	export default {
		data() {
			return {
				langs: '',
				systemlang: 'cn',
				banner: {},
				jiangjin: {},
				bannertr: {},
				year: (new Date()).getFullYear(),
				curyear: (new Date()).getFullYear(),
				list: [],
				teams: [],
				match: [],
				match_set: [],
				modellist: [],
				matchhole: [],
				playoff: [],
				bygroup: "",
				listmode: "",
				matchmode: "",
				loading: true,
				backshow: false
			}
		},
		props: {

		},
		name: 'Home',
		components: {
			navs,
			Btn,
			Ad,
			Grbg,
			TMDF42,
			TDBG18,
			TDBGSRSQ,
			TDBGSRLQ,
			Grbg_net,
			Grbg_nnp,
			Swiper,
			SwiperSlide,
			share
		},
		created() {

			document.title = "排名 Leaderboard";
			// mt_name=起点中巡赛·厦门东方站&mtid=31948&lang=cn&device=web&mtround=2&mt_round_num=3&mt_start_date=2023-11-13&mt_end_date=2023-11-14&sortmode=BGS&gpid=&gptype=
			// mtid=31948&mtround=2&sortmode=BGS&gpid=
			this.systemlang = getSystemLang();
			this.langs = getLangAll(this.systemlang);
			var params = this.$route.query;
			var mt_id = "";
			if (this.getQueryVariable("MatchID") === false) {
				if (this.getQueryVariable("mtid") === false) {
					mt_id = 31934;
				} else {
					mt_id = this.getQueryVariable("mtid");
				}
			} else {
				mt_id = this.getQueryVariable("MatchID");
			}
			// var mt_id = this.getQueryVariable("MatchID")===false?31934:this.getQueryVariable("MatchID");
			if (params.RoundID == undefined) {
				if (params.mtround == undefined) {
					var rd_id = ""
				} else {
					var rd_id = params.mtround;
				}
			} else {
				var rd_id = params.RoundID;
			}
			// var rd_id = params.RoundID==undefined?"":params.RoundID;
			var list = params.list == undefined ? (params.sortmode == undefined ? "" : params.sortmode) : params.list;
			var bygroup = params.bygroup == undefined ? "" : params.bygroup;
			var lang = params.lang == undefined ? "" : params.lang;
			var g = params.g == undefined ? (params.gpid == undefined ? "" : params.gpid) : params.g;
			var modal = params.modal == undefined ? "" : params.modal;
			this.modal = modal;
			this.listmode = list;
			this.bygroup = bygroup;
			this.loading = true;
			axios('match/rankbgs/run', {
					mt_id: mt_id,
					rd_id: rd_id,
					list: list,
					bygroup: bygroup,
					lang: lang,
					gid: g,
					modal: modal
				})
				.then((res) => {
					var data = res.data.data;
					if (rd_id == '') {
						this.rd_id = data.match_set.rd_id;
					} else {
						this.rd_id = rd_id;
					}
					this.list = data.list;
					console.log("this.teams", data.teams);
					this.teams = data.teams;
					for (var k in this.list) {
						if (this.list[k].groupDetail != undefined) {
							this.list[k].groupDetail.gp_start_time = this.list[k].groupDetail.gp_start_time.substring(
								11, 16);
						}
					}
					this.fillPlayerSummaryFromScore(this.list);
					this.match = data.match;
					this.match_set = data.match_set;
					this.matchhole = data.matchhole;
					this.modellist = data.modellist;
					this.playoff = data.playoff;
					if (data.playoff.length == 0) {
						this.match.playoffhole = 0;
					}
					if (this.bygroup == 1) {
						if (this.matchhole.hole.length == 9) {
							this.matchmode = "group9";
						} else {
							this.matchmode = "group";
						}
					} else if (this.setmatchclass() == "QNCJ") {
						if (this.matchhole.hole.length == 9) {
							// this.matchmode = "TDBG9";
						} else {
							this.matchmode = "TDBG18";
						}
					} else if (this.setmatchclass() == "SRSQ") {
						if (this.matchhole.hole.length == 9) {
							// this.matchmode = "TDBGSRSQ9";
						} else {
							this.matchmode = "TDBGSRSQ";
						}
					} else if (this.setmatchclass() == "SRLQ") {
						if (this.matchhole.hole.length == 9) {
							// this.matchmode = "TDBGSRLQ9";
						} else {
							this.matchmode = "TDBGSRLQ";
						}
					} else if (this.setmatchclass() == "TDDF" || this.setmatchclass() == "TNDF") {
						this.matchmode = "TDDF";
					} else if (this.modal != 'NetScore' && this.matchhole.hole.length == 27) {
						this.matchmode = "BGS27";
					} else if (this.modal != 'NetScore' && this.matchhole.hole.length == 9) {
						this.matchmode = "BGS9";
					} else if (this.modal == 'NetScore' && (this.listmode == 'NNP' || this.match_set.mt_scoring_mode ==
							'NNP' || this.match_set.mt_scoring_mode == 'NNP_ZBCD')) {
						if (this.match_set.mt_scoring_mode == 'NNP_ZBCD') {
							this.matchmode = "NNP_ZBCD";
							this.listmode = 'NNP_ZBCD';
						} else {
							this.matchmode = "NNP";
						}
					} else if (this.modal == 'NetScore' && (this.listmode == 'ZBCD' || this.match_set
							.mt_scoring_mode == 'ZBCD')) {
						this.matchmode = "ZBCD";
					} else if (this.modal != 'NetScore') {
						this.matchmode = "BGS";
					}
					// this.matchmode="group9";
					// this.matchmode = "TDBGSRLQ";
					console.log(this.matchmode) // = "BGS9";
					this.loading = false;

				});
			var ua = navigator.userAgent.toLowerCase();
			if (ua.match(/MicroMessenger/i) == "micromessenger") {
				//ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
				wx.miniProgram.getEnv((res) => {
					if (res.miniprogram) {
						// alert("在小程序里");
						this.backshow = false;
					} else {
						// alert("不在小程序里");
						this.backshow = true;
					}
				})
			} else {
				// alert('不在微信里');
				this.backshow = true;
			}
		},
		setup() {
			const onSwiper = (swiper) => {};
			const onSlideChange = (e) => {};
			const autoplayOptions = {
				delay: 5000,
				disableOnInteraction: false,
				loop: false,
				pauseOnMouseEnter: true,
				reverseDirection: true
			};
			return {
				onSwiper,
				onSlideChange,
				autoplayOptions,
				modules: [Pagination, Autoplay],
			};
		},
		methods: {
			getQueryVariable(variable) {
				var query = window.location.search.substring(1);
				var vars = query.split("&");
				var returnval = "";
				for (var i = 0; i < vars.length; i++) {
					var pair = vars[i].split("=");
					if (pair[0] == variable) {
						returnval = pair[1];
					}
				}
				if (returnval != "") {
					return returnval;
				}
				return (false);
			},
			setmatchclass() {
				var glist = [];
				var matchmodelist = [];
				var matchclass = this.match.class;
				var nttype = 'T';
				if (this.match_set.match_per == 1 || this.match_set.match_tm == 0) {
					nttype = 'T';
					if (this.match_set.mt_scoring_mode == 'NNP' || this.match_set.mt_scoring_mode == 'ZBCD' || this
						.match_set.mt_scoring_mode == 'NNP_ZBCD') {
						matchmodelist.push({
							value: "BGS",
							label: this.langs.BGS,
							nttype: 'T',
							gptype: 'P'
						})
						nttype = 'N';
					}
					var str = "";
					str = this.langs[this.match_set.mt_scoring_mode]
					matchmodelist.push({
						value: this.match_set.mt_scoring_mode,
						label: str,
						nttype: nttype,
						gptype: 'P'
					})
					for (var k in matchclass) {
						if (matchclass[k].gtype == 'P') {
							matchclass[k]["gid"] = matchclass[k]["gid"] + '';
							// matchclass[k]["gname"] = this.langs.gerensai+'---'+matchclass[k]["gname"];
							matchclass[k]["gname"] = matchclass[k]["gname"];
							glist.push(matchclass[k]);
						} else {
							continue;
						}
					}
				}
				if (this.match_set.match_tm == 1) {
					nttype = 'T';
					var str = "";
					str = this.langs[this.match_set.score_type]
					matchmodelist.push({
						value: this.match_set.score_type,
						label: str,
						nttype: nttype,
						gptype: 'T'
					})
					for (var k in matchclass) {
						if (matchclass[k].gtype == 'T') {
							matchclass[k]["gid"] = matchclass[k]["gid"] + '';
							// matchclass[k]["gname"] = this.langs.tuanduisai+'---'+matchclass[k]["gname"];
							matchclass[k]["gname"] = matchclass[k]["gname"];
							glist.push(matchclass[k]);
						} else {
							continue;
						}
					}
				}
				console.log("matchmodelist", matchmodelist)
				this.matchmodelist = matchmodelist;
				if (matchmodelist.length == 0) {
					return "";
				}
				var inmatchmodelist = 0;
				var curlistmode = this.listmode;
				if ((curlistmode == "NNP" || curlistmode == "NNP_ZBCD") && this.modal != 'NetScore') {
					curlistmode = "BGS";
				}
				for (var k in matchmodelist) {
					if (matchmodelist[k].value == curlistmode) {
						inmatchmodelist = 1;
						break;
					}
				}
				if (curlistmode == undefined || inmatchmodelist == 0) {
					var matchmode = matchmodelist[0].value;
				} else {
					var matchmode = curlistmode;
				}
				return matchmode;
			},
			// 接口未返回 playerSummary 时，用逐洞成绩兜底生成个人总杆汇总并排名
			fillPlayerSummaryFromScore(list) {
				if (!list || !list.length) {
					return;
				}
				var needFill = false;
				for (var i = 0; i < list.length; i++) {
					if (!list[i].playerSummary && list[i].playerScore && list[i].playerScore.length) {
						needFill = true;
						break;
					}
				}
				if (!needFill) {
					return;
				}
				for (var i = 0; i < list.length; i++) {
					var item = list[i];
					if (item.playerSummary || !item.playerScore || !item.playerScore.length) {
						continue;
					}
					var thru = 0;
					var score = 0;
					var to_par = 0;
					var holes = item.playerScore;
					for (var h = 0; h < holes.length; h++) {
						var hole = holes[h];
						var sc = hole && hole.score != null ? Number(hole.score) : 0;
						if (!sc || sc == 31) {
							continue;
						}
						thru++;
						score += sc;
						to_par += hole.to_par != null ? Number(hole.to_par) : 0;
					}
					if (thru == 0) {
						continue;
					}
					item.playerSummary = {
						pl_id: item.pl_id,
						thru: thru,
						score: score,
						to_par: to_par,
						totalscore: score,
						totalto_par: to_par,
						rank: 0,
						rank_code: "",
						sts: "",
						change: ""
					};
				}
				var ranked = list.filter(function(item) {
					return item.playerSummary && item.playerSummary.thru > 0 && (!item.matchPlayer || !item.matchPlayer.mp_sts);
				});
				ranked.sort(function(a, b) {
					var at = a.playerSummary.totalto_par;
					var bt = b.playerSummary.totalto_par;
					if (at != bt) {
						return at - bt;
					}
					if (b.playerSummary.thru != a.playerSummary.thru) {
						return b.playerSummary.thru - a.playerSummary.thru;
					}
					return a.playerSummary.score - b.playerSummary.score;
				});
				var rank = 1;
				for (var r = 0; r < ranked.length; r++) {
					if (r > 0) {
						var prev = ranked[r - 1].playerSummary;
						var cur = ranked[r].playerSummary;
						if (prev.totalto_par == cur.totalto_par && prev.thru == cur.thru && prev.score == cur.score) {
							cur.rank = prev.rank;
							cur.rank_code = "T";
							prev.rank_code = "T";
						} else {
							rank = r + 1;
							cur.rank = rank;
						}
					} else {
						ranked[r].playerSummary.rank = 1;
					}
				}
				list.sort(function(a, b) {
					var as = a.matchPlayer && a.matchPlayer.mp_sts ? 1 : 0;
					var bs = b.matchPlayer && b.matchPlayer.mp_sts ? 1 : 0;
					if (as != bs) {
						return as - bs;
					}
					var ar = a.playerSummary && a.playerSummary.rank ? a.playerSummary.rank : 9999;
					var br = b.playerSummary && b.playerSummary.rank ? b.playerSummary.rank : 9999;
					if (ar != br) {
						return ar - br;
					}
					var at = a.playerSummary ? a.playerSummary.totalto_par : 9999;
					var bt = b.playerSummary ? b.playerSummary.totalto_par : 9999;
					return at - bt;
				});
			},
		}

	}
</script>


<style scoped="scoped">
	.lf_loading_box {
		width: 100%;
		height: 100%;
		position: fixed;
		z-index: 999;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #005288;
	}

	.lf_loading_box .lf_w32h32 {
		width: 1.28rem;
		height: 1.28rem;
		position: relative;
		
	}
	.lf_w32h32_0{
		width: 100%;
		height: 100%;
		border: 2px dashed #ffffff4d;
		position: absolute;
		border-radius:50%;
	}
	.lf_w32h32_1,.lf_w32h32_2,.lf_w32h32_3{
		width: 100%;
		height: 100%;
		position: absolute;
	}
	.lf_rounded-full{
		width: 0.16rem;
		height: 0.16rem;
		position: absolute;
		background-color: #fff;
		border-radius: 50%;
	}
	.lf_w32h32_1 .lf_rounded-full{
		top: 0;
		margin-top: -0.07rem;
		left: 50%;
		margin-left: -0.07rem;
		
	} 
	.lf_w32h32_2 .lf_rounded-full{
		right: 0;
		margin-right: -0.07rem;
		top: 50%;
		margin-top: -0.07rem;
		
	} 
	.lf_w32h32_3 .lf_rounded-full{
		bottom: 0;
		margin-bottom: -0.07rem;
		left: 50%;
		margin-left: -0.07rem;
		
	} 
	.lf_w32h32_1{
		animation: spin 1s linear infinite;
	}
	.lf_w32h32_2{
		animation: spin-reverse 1.5s linear infinite;
	}
	.lf_w32h32_3{
		animation: spin 1.5s linear infinite;
	}
	.lf_animation_ {
		animation: anim 300ms ease-in 1;
		/* 使用简写属性 */
	}
	@keyframes spin{
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
		
	}
	@keyframes spin-reverse{
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(-360deg);
		}
	}
	@keyframes anim {
		0% {
			opacity: 0;
		}

		100% {
			opacity: 1;
		}
	}

	@media screen and (max-width: 768px) {}
</style>